export default __webpack_public_path__ + "504d3de653460ab556c342528a98892c.mov";